
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30762',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30762",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55285",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8317",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11773",
  "I18n": "static-7.1669",
  "quartz": "static-1.7436",
  "quartz-config": "static-1.1214",
  "quartz-core": "static-1.6655",
  "react-dlb": "static-1.88",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.78",
  "reselect": "static-3.10",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.906",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55272",
  "feedback-utils": "static-1.55276",
  "forms-embed-utils-lib": "static-1.4750",
  "forms-utils-lib": "static-1.13072",
  "foundations-assets": "static-1.5168",
  "foundations-components": "static-1.8468",
  "foundations-theming": "static-1.4756",
  "hub-http": "static-1.6499",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12080",
  "icons": "static-2.680",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4121",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17004",
  "react-select-plus": "static-1.111",
  "react-utils": "static-2.5545",
  "react-virtualized": "static-2.105",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.501",
  "tinymce-plugins": "static-1.58187",
  "transmute": "static-2.97",
  "ui-images": "static-2.1243",
  "UIComponents": "static-3.8719",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3609",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3713",
  "quartz-webpack": "static-1.3660",
  "foundations-theming-specialty": "static-1.2472",
  "property-description-translator": "static-1.4125",
  "HeadJS": "static-2.794",
  "framer-motion": "static-1.77",
  "hs-test-utils-bend-plugin": "static-1.3428",
  "msw": "static-1.39",
  "testing-library": "static-1.157",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.89",
  "jasmine": "static-4.4598",
  "jasmine-runner": "static-1.6737",
  "opentelemetry-fe-types": "static-1.54",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.876",
  "hubspotter-http": "static-1.4853",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.31",
  "opentelemetry-fe": "static-1.429",
  "quartz-auth": "static-1.1111",
  "quartz-head": "static-1.1101",
  "quartz-i18n": "static-1.1111",
  "quartz-routing": "static-1.866",
  "quartz-test": "static-1.1111",
  "quartz-tracking": "static-1.815",
  "trellis-components": "static-1.2617",
  "ui-fonts": "static-1.1035",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.176",
  "conversations-skeleton-state": "static-1.7531",
  "reference-resolvers": "static-1.8466",
  "sanitize-text": "static-1.8439",
  "PatternValidationJS": "static-1.3179",
  "ReduxMessenger": "static-2.10654",
  "outpost": "static-1.4441",
  "rpc-client-utils": "static-1.4951",
  "sanitize": "static-1.4758",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4737",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9710",
  "react-aria": "static-1.71",
  "react-create-root-preference": "static-1.68",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2598",
  "bend-plugin-foundations-theming": "static-1.3239",
  "foundations-theming-base": "static-1.3741",
  "stylex": "static-1.39",
  "hs-locale-management": "static-1.283",
  "csstype": "static-1.50",
  "web-vitals": "static-1.13",
  "ai-components-ui-library": "static-1.9681",
  "atom": "static-1.5370",
  "codemirror": "static-5.100",
  "content-assistance-lib": "static-1.8179",
  "ContentUtils": "static-1.69097",
  "data-token-picker": "static-1.16866",
  "file-manager-components": "static-1.24455",
  "FileManagerCore": "static-1.39954",
  "FileManagerLib": "static-1.40095",
  "frontend-preferences-client": "static-1.8208",
  "hub-http-contrib": "static-1.3324",
  "interframe": "static-3.5040",
  "layout-dnd-components": "static-1.12943",
  "layout-dnd-utils": "static-1.11918",
  "property-translator": "static-1.5681",
  "react-codemirror": "static-1.10925",
  "react-colorpicker": "static-2.10501",
  "reference-resolvers-lite": "static-1.8387",
  "rich-text-lib": "static-1.20283",
  "tinymce-data": "static-1.41158",
  "tinymce-themes": "static-1.57043",
  "ui-addon-emoji-picker": "static-1.10171",
  "ui-addon-sales-email": "static-1.5497",
  "ui-brand-identity-lib": "static-1.16425",
  "bender-build-tools": "static-1.3431",
  "opentelemetry-web": "static-1.11",
  "hub-http-shared-msw-handlers": "static-1.10590",
  "hubspotter-http-shared-msw-handlers": "static-1.10588",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.20",
  "react-day-picker": "static-1.8",
  "trellis-theming": "static-1.1260",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.361",
  "chirp-fetch": "static-1.2179",
  "stylex-utils": "static-1.138",
  "chatspot-core": "static-1.22932",
  "copilot-toolkit": "static-1.11823",
  "customer-data-objects-ui-components": "static-1.13317",
  "data-fetching-client": "static-1.9942",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5041",
  "ui-addon-video-player": "static-1.8987",
  "ui-coaching-tips": "static-1.29276",
  "usage-tracker": "static-1.7637",
  "cms-field-types": "static-1.5099",
  "content-icons-ui": "static-1.2348",
  "integrations-lib": "static-1.16997",
  "customer-data-objects": "static-1.7976",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1689",
  "apollo-link-hub-http": "static-2.4940",
  "apollo-stack-hubspot": "static-3.92",
  "graphql": "static-1.87",
  "immer": "static-1.99",
  "immerable": "static-1.4434",
  "ui-addon-iframeable": "static-1.9362",
  "video-components-external": "static-1.12123",
  "video-data-lib": "static-1.35781",
  "breeze-artifacts-sdk": "static-1.286",
  "audio-components": "static-1.6321",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29787",
  "FileManagerImages": "static-1.37606",
  "foundations-components-legacy": "static-1.1493",
  "html-to-image": "static-1.59",
  "redux-toolkit": "static-1.76",
  "salesImages": "static-1.547",
  "ui-universal-auth": "static-1.9378",
  "urlinator": "static-1.4817",
  "video-components": "static-1.14125",
  "video-embed": "static-1.36615",
  "ts-schema": "static-1.4283",
  "ContentData": "static-1.69172",
  "layout-data-lib": "static-1.10243",
  "react-dnd-compat": "static-1.4903",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1828",
  "external-options-client-types": "static-1.4328",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7178",
  "hs-promise-utils": "static-1.5881",
  "inbound-db-properties-service-client": "static-1.4046",
  "NamespacedHubStyle": "static-2.9253",
  "growth-onboarding-confetti": "static-1.3346",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11431",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5741",
  "magpie-types": "static-1.5201",
  "simple-logging-lib": "static-1.3336",
  "avatar-components": "static-1.2766",
  "customer-data-ui-utilities": "static-1.10114",
  "growth-onboarding-feedback-components": "static-1.6869",
  "flux-actions": "static-1.366",
  "hubspot-apollo-client": "static-1.5163",
  "integrations-error-boundary-lib": "static-1.14412",
  "integrations-tracking-lib": "static-1.5893",
  "laboratory-lib": "static-3.7437",
  "native-integrations-shared-strings": "static-1.8063",
  "redux-observable": "static-1.73",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10554",
  "unified-auth": "static-1.892",
  "breeze-engine-chat-components": "static-1.667",
  "breeze-engine-core": "static-1.967",
  "ably": "static-2.2",
  "highlight.js": "static-1.84",
  "navigation-messaging": "static-1.8124",
  "content-media-composition-data-lib": "static-1.13205",
  "content-media-compositions": "static-2.17212",
  "idb-keyval": "static-1.49",
  "media-bridge-lib": "static-1.19384",
  "unified-auth-core-lib": "static-1.1174",
  "social-insights-client-types": "static-1.22706",
  "advanced-menus-core": "static-1.15555",
  "advanced-menus-lib": "static-1.12431",
  "ExportDialog": "static-6.10662",
  "ui-memberships-settings-lib": "static-1.34813",
  "conditional-properties-service-client": "static-1.4002",
  "crm-pipelines-api-client-types": "static-1.4337",
  "fdsr-migration-layer": "static-1.297",
  "framework-builder-read-service-client": "static-1.4211",
  "framework-data-schema-quick-fetch": "static-1.7083",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3897",
  "persist-promise": "static-1.3985",
  "foundations-components-test-utils": "static-1.5951",
  "reactive-lib": "static-1.1004",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.622",
  "universal-page-editor-lib": "static-1.3294",
  "adobe-sign-auth-lib": "static-1.431",
  "ads-unified-auth-lib": "static-1.1279",
  "generic-oauth-auth-lib": "static-1.20",
  "google-sheets-integration-lib": "static-1.999",
  "microsoft-drive-auth-lib": "static-1.109",
  "surveymonkey-integration-lib": "static-1.447",
  "slack-ui-library": "static-1.10683",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4034",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15554",
  "simple-menus-lib": "static-1.17071",
  "crm-record-cards-service-types": "static-1.3776",
  "location-customization-utils-lib": "static-1.10067",
  "react-flip-move": "static-1.76"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30762",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55285",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8317",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11773",
  "I18n": "/I18n/static-7.1669",
  "quartz": "/quartz/static-1.7436",
  "quartz-config": "/quartz-config/static-1.1214",
  "quartz-core": "/quartz-core/static-1.6655",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.78",
  "reselect": "/reselect/static-3.10",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.906",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55272",
  "feedback-utils": "/feedback-utils/static-1.55276",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4750",
  "forms-utils-lib": "/forms-utils-lib/static-1.13072",
  "foundations-assets": "/foundations-assets/static-1.5168",
  "foundations-components": "/foundations-components/static-1.8468",
  "foundations-theming": "/foundations-theming/static-1.4756",
  "hub-http": "/hub-http/static-1.6499",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12080",
  "icons": "/icons/static-2.680",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4121",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17004",
  "react-select-plus": "/react-select-plus/static-1.111",
  "react-utils": "/react-utils/static-2.5545",
  "react-virtualized": "/react-virtualized/static-2.105",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tinymce-plugins": "/tinymce-plugins/static-1.58187",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1243",
  "UIComponents": "/UIComponents/static-3.8719",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3609",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3713",
  "quartz-webpack": "/quartz-webpack/static-1.3660",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2472",
  "property-description-translator": "/property-description-translator/static-1.4125",
  "HeadJS": "/HeadJS/static-2.794",
  "framer-motion": "/framer-motion/static-1.77",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3428",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.157",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.89",
  "jasmine": "/jasmine/static-4.4598",
  "jasmine-runner": "/jasmine-runner/static-1.6737",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.54",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.876",
  "hubspotter-http": "/hubspotter-http/static-1.4853",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.31",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.429",
  "quartz-auth": "/quartz-auth/static-1.1111",
  "quartz-head": "/quartz-head/static-1.1101",
  "quartz-i18n": "/quartz-i18n/static-1.1111",
  "quartz-routing": "/quartz-routing/static-1.866",
  "quartz-test": "/quartz-test/static-1.1111",
  "quartz-tracking": "/quartz-tracking/static-1.815",
  "trellis-components": "/trellis-components/static-1.2617",
  "ui-fonts": "/ui-fonts/static-1.1035",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.176",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7531",
  "reference-resolvers": "/reference-resolvers/static-1.8466",
  "sanitize-text": "/sanitize-text/static-1.8439",
  "PatternValidationJS": "/PatternValidationJS/static-1.3179",
  "ReduxMessenger": "/ReduxMessenger/static-2.10654",
  "outpost": "/outpost/static-1.4441",
  "rpc-client-utils": "/rpc-client-utils/static-1.4951",
  "sanitize": "/sanitize/static-1.4758",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4737",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9710",
  "react-aria": "/react-aria/static-1.71",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2598",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3239",
  "foundations-theming-base": "/foundations-theming-base/static-1.3741",
  "stylex": "/stylex/static-1.39",
  "hs-locale-management": "/hs-locale-management/static-1.283",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.13",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9681",
  "atom": "/atom/static-1.5370",
  "codemirror": "/codemirror/static-5.100",
  "content-assistance-lib": "/content-assistance-lib/static-1.8179",
  "ContentUtils": "/ContentUtils/static-1.69097",
  "data-token-picker": "/data-token-picker/static-1.16866",
  "file-manager-components": "/file-manager-components/static-1.24455",
  "FileManagerCore": "/FileManagerCore/static-1.39954",
  "FileManagerLib": "/FileManagerLib/static-1.40095",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8208",
  "hub-http-contrib": "/hub-http-contrib/static-1.3324",
  "interframe": "/interframe/static-3.5040",
  "layout-dnd-components": "/layout-dnd-components/static-1.12943",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11918",
  "property-translator": "/property-translator/static-1.5681",
  "react-codemirror": "/react-codemirror/static-1.10925",
  "react-colorpicker": "/react-colorpicker/static-2.10501",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8387",
  "rich-text-lib": "/rich-text-lib/static-1.20283",
  "tinymce-data": "/tinymce-data/static-1.41158",
  "tinymce-themes": "/tinymce-themes/static-1.57043",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10171",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5497",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16425",
  "bender-build-tools": "/bender-build-tools/static-1.3431",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10590",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10588",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.20",
  "react-day-picker": "/react-day-picker/static-1.8",
  "trellis-theming": "/trellis-theming/static-1.1260",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.361",
  "chirp-fetch": "/chirp-fetch/static-1.2179",
  "stylex-utils": "/stylex-utils/static-1.138",
  "chatspot-core": "/chatspot-core/static-1.22932",
  "copilot-toolkit": "/copilot-toolkit/static-1.11823",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13317",
  "data-fetching-client": "/data-fetching-client/static-1.9942",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5041",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8987",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29276",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "cms-field-types": "/cms-field-types/static-1.5099",
  "content-icons-ui": "/content-icons-ui/static-1.2348",
  "integrations-lib": "/integrations-lib/static-1.16997",
  "customer-data-objects": "/customer-data-objects/static-1.7976",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1689",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4940",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.92",
  "graphql": "/graphql/static-1.87",
  "immer": "/immer/static-1.99",
  "immerable": "/immerable/static-1.4434",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9362",
  "video-components-external": "/video-components-external/static-1.12123",
  "video-data-lib": "/video-data-lib/static-1.35781",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.286",
  "audio-components": "/audio-components/static-1.6321",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29787",
  "FileManagerImages": "/FileManagerImages/static-1.37606",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1493",
  "html-to-image": "/html-to-image/static-1.59",
  "redux-toolkit": "/redux-toolkit/static-1.76",
  "salesImages": "/salesImages/static-1.547",
  "ui-universal-auth": "/ui-universal-auth/static-1.9378",
  "urlinator": "/urlinator/static-1.4817",
  "video-components": "/video-components/static-1.14125",
  "video-embed": "/video-embed/static-1.36615",
  "ts-schema": "/ts-schema/static-1.4283",
  "ContentData": "/ContentData/static-1.69172",
  "layout-data-lib": "/layout-data-lib/static-1.10243",
  "react-dnd-compat": "/react-dnd-compat/static-1.4903",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1828",
  "external-options-client-types": "/external-options-client-types/static-1.4328",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7178",
  "hs-promise-utils": "/hs-promise-utils/static-1.5881",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4046",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9253",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3346",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11431",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5741",
  "magpie-types": "/magpie-types/static-1.5201",
  "simple-logging-lib": "/simple-logging-lib/static-1.3336",
  "avatar-components": "/avatar-components/static-1.2766",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10114",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6869",
  "flux-actions": "/flux-actions/static-1.366",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5163",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14412",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5893",
  "laboratory-lib": "/laboratory-lib/static-3.7437",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8063",
  "redux-observable": "/redux-observable/static-1.73",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10554",
  "unified-auth": "/unified-auth/static-1.892",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.667",
  "breeze-engine-core": "/breeze-engine-core/static-1.967",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.84",
  "navigation-messaging": "/navigation-messaging/static-1.8124",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13205",
  "content-media-compositions": "/content-media-compositions/static-2.17212",
  "idb-keyval": "/idb-keyval/static-1.49",
  "media-bridge-lib": "/media-bridge-lib/static-1.19384",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1174",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "advanced-menus-core": "/advanced-menus-core/static-1.15555",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12431",
  "ExportDialog": "/ExportDialog/static-6.10662",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34813",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4002",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4337",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.297",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4211",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7083",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3897",
  "persist-promise": "/persist-promise/static-1.3985",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5951",
  "reactive-lib": "/reactive-lib/static-1.1004",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.622",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3294",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.431",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1279",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.20",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.999",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.109",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.447",
  "slack-ui-library": "/slack-ui-library/static-1.10683",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4034",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15554",
  "simple-menus-lib": "/simple-menus-lib/static-1.17071",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3776",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10067",
  "react-flip-move": "/react-flip-move/static-1.76"
}
};
